<template>
  <div>
    <h1 class="title has-text-centered">Stories</h1>

    <p class="notification is-info has-text-centered">
      <span class="has-text-weight-semibold">NB:</span> Think about it!!
    </p>

    <div class="columns is-multiline">
      <div v-for="post in posts" :key="post.id" class="column is-12-mobile is-6-tablet is-4-desktop">
        <div class="card post-preview" @click="openModal(post)">
          <div class="card-content">
            <h2 class="title is-4">{{ post.title }}</h2>
            <p class="subtitle is-6">{{ post.excerpt }}</p>
          </div>
        </div>
      </div>
    </div>
<br>
<br>
    <!-- Modal for Posts -->
    <div class="modal" v-if="isModalOpen" @click.self="closeModal">
      <div class="modal-content" ref="modalContent">
        <span class="close" @click="closeModal">&times;</span>
        <div v-if="currentPost">
          <h2>{{ currentPost.title }}</h2>
          <p v-html="currentPost.fullText"></p>
        </div>
        <button @click="prevPost" class="nav-button prev">&lt;</button>
        <button @click="nextPost" class="nav-button next">&gt;</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoriesPage',
  data() {
    return {
      posts: [
        {
    "id": 1,
    "title": "The Girl Who Vanished From My Hospital Bedside",
    "excerpt": "A tale of asthma, loss, and the one friendship that almost healed me until it disappeared without a goodbye...",
    "fullText": `
        I’ve been asthmatic for as long as I can remember, even though now I believe I am fully healed. 
        Not the "cough here and there" kind. The serious kind. 
        The kind where hospitals felt more like home than my own house. I knew the sound of a nebulizer before I knew the sound of a school bell.

        My dad used to tell me stories about my mum, Susan Wairimu (may she rest in peace). 
        One story in particular still makes me pause. Apparently, when I was really little, Mum once rushed me to the hospital in full panic mode. 
        She looked at me, decided I wasn’t breathing, and before even talking to a doctor, she just left me there. 
        She thought I was gone. Just like that, dropped off her “dead” child at the hospital. 
        Of course, I wasn’t actually dead. Maybe I was just taking a dramatic nap. 
        Or maybe I was already rehearsing for my future role as "The Boy Who Refuses to Die."

        Fast forward to when I was nine. Mum was gone by then. 
        I found myself in Mathari Hospital, in the children’s ward. 
        That’s where I met her, my hospital best friend. 
        It’s strange, I can’t remember her name now, but back then she felt like family. 
        Her parents visited me, and my dad and aunt visited her. 
        We played together when we felt stronger, simple games, silly jokes, sometimes just lying in bed talking about nothing at all. 
        In a place where everything smelled of medicine and bleach, she was the one thing that felt safe.

        Then came the day that changed everything.
        I was given a strong injection, and it knocked me out for the entire day. 
        When I woke up, I noticed her things, her toys, her small bag, sitting by my bed. But she wasn’t there.
        I asked the nurse where she was.
        "Oh, she went home," the nurse said, as if it was nothing.

        No goodbye.
        No “I’ll write you.”
        No “I’ll come visit.”

        She was just gone.

        My chest tightened, and not just from asthma. 
        My health crashed, my breathing worsened, and I was back to square one. 
        The doctors kept me for another two weeks. Not just because my lungs were weak, but because my little nine-year-old heart had taken a blow it didn’t know how to recover from.

        It’s strange how a short friendship can mean the world to a child, especially one trapped in a place where life feels so fragile. 
        Looking back, I can laugh at parts of it. Like how Mum once abandoned “dead me” at the hospital, who does that?
        But some parts still sting. Because when you’re young, you think the people who make you smile will always be there, until one day, they’re not.

        And sometimes, no matter how much your body wants to heal, it’s your heart that decides whether you do.`
},
        {
          id: 2,
          title: 'The Brave Little Toaster',
          excerpt: 'An inspiring tale...',
          fullText: `
            I am a Rasta man, and this is the story of the bravest little toaster you'll ever hear about. Now, you might wonder what a toaster has to do with a Rasta, but I promise you, it's a tale worth telling.

            One fine morning, I was lounging in my small but cozy kitchen, the aroma of freshly brewed coffee mixing with the scent of sweet ganja. The sun was streaming through the window, casting golden rays on my favorite appliance: my trusty old toaster. It wasn't just any toaster; it was a brave little toaster with a spirit that couldn't be tamed.

            You see, this toaster had been with me through thick and thin. It had toasted bread for countless meals, warmed my fingers on chilly mornings, and even made me smile with its cheerful 'ding!' sound. But today, something extraordinary was about to happen.

            I had just placed two slices of bread into the toaster, eagerly waiting for that perfect golden-brown toast, when I heard a strange noise. A rumble, a clatter, and then... silence. The toaster had stopped working. My heart sank. I walked over, gave it a gentle tap, and suddenly, the toaster sprang back to life with a burst of energy.

            But it wasn't just toasting bread anymore. No, it was vibrating, shaking, and then, to my amazement, it started to speak. "I am the Brave Little Toaster," it said in a deep, resonant voice. "I have served you well, but now it's time for my greatest adventure."

            I blinked in disbelief. Was I dreaming? Was it the ganja playing tricks on me? But no, this was real. The toaster continued, "I have been chosen to save the world from the tyranny of the Cold Bread Syndicate. They seek to banish all warmth and toastiness from the planet, leaving everyone with cold, hard bread."

            With that, the toaster sprouted tiny legs and arms, and with a determined look, it jumped off the counter and headed for the door. I couldn't let my brave little toaster face this danger alone. I grabbed my coat, my hat, and a piece of toast for the road, and followed it out into the world.

            Together, we journeyed through the city, facing one obstacle after another. We dodged rain puddles, outsmarted curious cats, and even navigated a busy street. All the while, the toaster led the way with unwavering courage.

            Finally, we reached the Cold Bread Syndicate's headquarters, a tall, cold, and foreboding building. The toaster and I snuck inside, ready to confront the villainous leader, Freezer Fred. Fred was a tall, icy figure with a heart as cold as the bread he championed.

            The battle was fierce. Toast crumbs flew, sparks ignited, and at one point, I thought we might not make it. But the brave little toaster, with its glowing coils and fierce determination, fought valiantly. It toasted its way through the minions and finally faced Freezer Fred.

            With a mighty leap, the toaster launched itself at Fred, who melted under the sheer warmth of the brave little toaster's heroic spirit. The Cold Bread Syndicate was defeated, and the world was safe once more.

            As we walked back home, the toaster looked up at me and said, "Thank you for believing in me. Together, we made a difference." I smiled, knowing that this brave little toaster had taught me a valuable lesson: no matter how small or unlikely a hero may seem, with enough courage and heart, anything is possible.

            And so, we returned to our cozy kitchen, the sun setting in the distance. I placed the toaster back on the counter, and as I took a bite of my perfectly toasted bread, I knew that this was a story I would cherish forever.

            For I am a Rasta man, and this is the tale of the bravest little toaster who ever lived.
          `
        },
        {
          id: 3,
          title: 'A Vibe of Irie',
          excerpt: 'Just vibing...',
          fullText: `
            <p><strong>Scene:</strong> A bustling café in Nairobi, Kenya. The aroma of freshly brewed coffee fills the air as a group of friends—Chrispin, a laid-back rasta man with dreadlocks and a penchant for reggae music, his childhood friend Kendi, and their friend Mumbi, whom Chrispin secretly likes—gather around a table. </p>

           <p> <strong>Chrispin:</strong> <em>(leaning back, tapping his fingers to an imaginary reggae beat)</em> Jah bless, man. Dis coffee here, it’s pure irie, yah know?
           </p>
            <p><strong>Kendi:</strong> <em>(smiling)</em> Chrispin, every coffee tastes “irie” to you.
            </p>
            <p><strong>Mumbi:</strong> <em>(laughing)</em> He’s just saying that because he doesn’t want to admit he has no idea what he’s talking about.</p>

            <p><strong>Chrispin:</strong> <em>(playfully narrowing his eyes at Mumbi)</em> Eh, you doubt I’m a connoisseur? I got taste, Mumbi. I know good vibes when I feel ‘em.</p>

          <p>  <strong>Mumbi:</strong> <em>(smirking)</em> Oh really? What kind of vibes are you feeling now?</p>

          <p>  <strong>Chrispin:</strong> <em>(shrugging nonchalantly)</em> Just good ones, you know? Chillin' with my bredren and sistren, nothing more pure than dat.</p>

           <p> <strong>Kendi:</strong> Come on, Chrispin, be honest. Who gives you the best vibes here?</p>

           <p> <strong>Chrispin:</strong> <em>(smiling slyly)</em> Well, if I had to pick...it would be...the coffee, of course.</p>

           <p> <strong>Mumbi:</strong> <em>(mocking hurt)</em> Ouch, Chrispin. You wound me. Here I thought we had a connection.</p>

           <p> <strong>Chrispin:</strong> <em>(laughing nervously)</em> You’re always trouble, Mumbi. Always making fun of dis rasta man.</p>

           <p> <strong>Kendi:</strong> <em>(teasingly)</em> Maybe she’s just trying to get your attention, Chrispin.</p>

           <p> <strong>Mumbi:</strong> <em>(rolling her eyes)</em> Please, Kendi. Chrispin wouldn’t notice if I danced on this table.</p>
<p>
            <strong>Chrispin:</strong> <em>(chuckling)</em> I would notice, but I’d probably just think you were dancing to the reggae beat in my head.</p>

           <p> <strong>Kendi:</strong> Speaking of dancing, remember that time in high school when you made a fool of yourself at the talent show?</p>

            <p><strong>Chrispin:</strong> <em>(groaning)</em> Don’t remind me. I thought I was the next Bob Marley.
            </p>
           <p> <strong>Mumbi:</strong> <em>(giggling)</em> You were adorable. You still have that charm, though.</p>

           <p> <strong>Chrispin:</strong> <em>(blushing slightly, rubbing his neck)</em> Ah, Mumbi, you’re too kind.</p>

           <p> <strong>Kendi:</strong> <em>(nudging Mumbi)</em> See how he gets all shy around you?</p>

           <p> <strong>Mumbi:</strong> <em>(raising an eyebrow)</em> Oh, I see. Chrispin, are you blushing?</p>

            <p><strong>Chrispin:</strong> <em>(trying to stay composed)</em> Maybe just a little. But remember, I’m a rasta man. Always cool and collected.</p>

            <p><strong>Kendi:</strong> <em>(laughing)</em> Sure, sure. Let’s see if you can keep up that cool when we hit the dance floor later.</p>

           <p> <strong>Chrispin:</strong> <em>(grinning)</em> Challenge accepted. But don’t be surprised if I bring the house down with my moves.</p>

         <p>   <strong>Mumbi:</strong> <em>(smiling)</em> I’m looking forward to it. Maybe you’ll even teach me a few moves.</p>

            <p><strong>Chrispin:</strong> <em>(playfully)</em> Only if you promise not to outshine me, Mumbi.</p>

          <p>  <strong>Kendi:</strong> <em>(raising her cup)</em> To good vibes, great friends, and unforgettable nights.</p>

            <p><strong>Chrispin:</strong> <em>(raising his cup)</em> Irie, man. Irie.</p>

            <p><strong>Mumbi:</strong> <em>(cheerfully)</em> Irie indeed.</p>
          `
        },
          {
  id: 4,
  title: 'The Irie Time Travel Tango',
  excerpt: 'Three versions of Chrispin in a time-warped chat!',
  fullText: `
    <p><strong>Scene:</strong> A cozy, dimly-lit room with a strong scent of incense wafting through the air. Three versions of Chrispin—Current Chrispin, Young Chrispin, and Future Chrispin—are gathered in a mystical, magical circle of light.</p>
    
    <p><strong>Current Chrispin:</strong> <em>(leaning back with a relaxed grin)</em> Man, I gotta ask. Do I ever get to bang my crush? I’m so curious, you know?</p>
    
    <p><strong>Future Chrispin:</strong> <em>(with a twinkle in his eye)</em> Ah, let me tell you, little man, it’s quite the tale. But first, let’s keep it hush-hush from our younger self here.</p>
    
    <p><strong>Young Chrispin:</strong> <em>(wide-eyed and bouncing with curiosity)</em> What’s up? What’s up? Tell me everything!</p>
    
    <p><strong>Current Chrispin:</strong> <em>(chuckling nervously)</em> Oh, come on, don't tease him. Just spill the beans!</p>
    
    <p><strong>Future Chrispin:</strong> <em>(dramatically)</em> Alright, picture this: I was chilling at the rasta carnival, you know, vibing with the beats and all. And there she was, looking like the goddess of reggae.</p>
    
    <p><strong>Young Chrispin:</strong> <em>(leaning in, eyes glued)</em> And then what happened?</p>
    
    <p><strong>Future Chrispin:</strong> <em>(winking at Current Chrispin)</em> I had to win her over with the ultimate dance-off. Imagine me, grooving like a king while juggling flaming coconuts.</p>
    
    <p><strong>Young Chrispin:</strong> <em>(giggling)</em> No way! That’s so cool!</p>
    
    <p><strong>Current Chrispin:</strong> <em>(trying to contain his laughter)</em> Yeah, yeah, but it wasn’t just the coconuts, right?</p>
    
    <p><strong>Future Chrispin:</strong> <em>(pretending to be serious)</em> Oh, indeed. I serenaded her with a song I wrote on a ukulele. Lyrics went something like this: “Oh, sweet lady, my heart’s been locked, but now you’ve got the key, so please don’t mock.”</p>
    
    <p><strong>Young Chrispin:</strong> <em>(bursting into laughter)</em> That’s hilarious! Did it work?</p>
    
    <p><strong>Future Chrispin:</strong> <em>(with a grin)</em> Well, let’s just say, by the end of the night, we were sharing the last mango on the beach.</p>
    
    <p><strong>Current Chrispin:</strong> <em>(trying to stay serious but failing)</em> And did you get the kiss under the stars?</p>
    
    <p><strong>Future Chrispin:</strong> <em>(playfully)</em> Oh, absolutely! But let’s just say I had to dodge a few flying coconuts and a rogue drum solo to make it happen.</p>
    
    <p><strong>Young Chrispin:</strong> <em>(eyes wide and mouth agape)</em> That’s amazing! I can’t wait to be you!</p>
    
    <p><strong>Current Chrispin:</strong> <em>(laughing)</em> Yeah, just remember, kid, it’s not always about the dramatic moments. Sometimes, it’s the little things that count.</p>
    
    <p><strong>Future Chrispin:</strong> <em>(smiling knowingly)</em> Exactly. Now, let’s keep this conversation between us. Don’t want to spoil the fun for the little guy here.</p>
    
    <p><strong>Young Chrispin:</strong> <em>(scratching his head)</em> Wait, what are you guys not telling me?</p>
    
    <p><strong>Current Chrispin:</strong> <em>(looking at Future Chrispin)</em> Maybe we should let him have a little surprise. The journey’s half the fun, after all.</p>
    
    <p><strong>Future Chrispin:</strong> <em>(nodding)</em> Agreed. And who knows, maybe one day he’ll be telling his own tales, just like us. Keep it irie, my younger self.</p>
    
    <p><strong>Young Chrispin:</strong> <em>(grinning)</em> I’m so ready! Thanks, guys!</p>
  `
},
        {
    "id": 5,
    "title": "The Logical Rasta and the Creator of Everything",
    "excerpt": "A funny and mind-bending tale...",
    "fullText": `
        I am a Rasta man, and this is the story of how I, a handsome and logical fellow, concluded that God exists. Now, let me start by saying that in life, nobody truly deserves anything, but somehow, we all have something. For instance, I have my devastatingly good looks, and trust me, it's both a blessing and a burden. How can you focus on philosophy when the mirror keeps whispering, "Look at you, starboy"?

        Anyway, one sunny afternoon, I was chilling in my yard, sipping on coconut water, my dreadlocks swaying in the breeze. My mind was cruising through thoughts deeper than the ocean. Suddenly, my brethren Jerry popped by and hit me with the classic question: "Rasta, does God really exist?"

        Now, Jerry is the kind of man who likes to answer questions with more questions. If you ask him the time, he'll say, "Does time even exist, my youth?" But this time, he just sat there scratching his head and said, "I don't know, maybe there's nothing."

        "Ah, Jerry, my brother," I said, "you just said nothing, but do you even realize that 'nothing' is a concept? If you believe we came from nothing, you're admitting that nothing is a 'something'—a non-existent creator, if you will."

        Jerry looked at me, his eyebrows tangled in confusion. "But, Rasta, how can nothing be something?"

        I laughed, taking another sip of coconut water. "See it this way: if you say we came from nothing, and when we die, 'nothing' happens, then you believe in this 'nothing' as a force, a beginning, a cause. So, Jerry, if 'nothing' is the cause, then isn't it just another name for something greater—a Creator?"

        Jerry's jaw dropped, but I wasn't done. "Logically speaking, everything in this world has a cause and effect. Like the cause of my believing in God was realizing how perfectly this universe works. The sun rises, the rain falls, and my skin glows like the morning dew. All these are effects of something grander."

        Jerry blinked. "Okay, Rasta, but what caused the first effect? What started it all?"

        I leaned back, hands behind my head, my logic flowing like reggae beats. "Now you're asking the right question, Jerry. If everything has a cause and effect, then something had to cause the first effect to ever exist. Saying 'nothing' caused it would be dumb, because, as we've established, nothing doesn't just happen. There had to be a Creator, something beyond time and space, who kicked it all off."

        Jerry scratched his chin, nodding slowly. "So, you're saying God exists because nothing can't explain itself?"

        I grinned, the sun glinting off my perfect teeth. "Exactly, my youth. Logic and vibes lead to the same conclusion: a Creator exists, and we are part of His grand design."

        Jerry sat back, his mind clearly blown. "Rasta, you might just be the most logical man I've ever met."

        I shrugged, modest as always. "It comes naturally, Jerry. Just like my good looks."

        And so, we sat there, two logical brethren basking in the warmth of the sun and the profound realization that the universe, in all its glory, is no accident. For I am a Rasta man, and this is the story of how logic, vibes, and a little bit of humor led me to the Creator of everything.
    `
},
        {
    "id": 6,
    "title": "The Flowers I Didn't See",
    "excerpt": "A bittersweet reflection...",
    "fullText": `
        I am a Rasta man, and this is the story of the first flowers I ever received. It's a story wrapped in love, sadness, and some heavy truths about life and men. 

        You see, most men never get flowers until the day they're lying still in the earth, their hands crossed on their chest. That's the first time someone remembers to lay blooms at their feet. But me? I got my first flowers while I was still breathing, still walking this green earth. And they came from a girl I loved—a girl who left.

        Her name doesn’t matter as much as the memory does. She gave me those flowers one afternoon, a small bouquet she said she picked because "they reminded her of me." At the time, I didn’t think much of it. Flowers? For me? I laughed, called her sweet, and put them on the kitchen table. But now, looking back, I wonder if they’ll be the last flowers I ever get while I’m alive.

        She’s gone now. Maybe I healed, maybe I didn’t—it’s hard to tell with these things. But her leaving left me with food for thought. I started wondering how many men out there, like me, don’t even notice when someone treats them right. How many of us go through life thinking scraps are feasts, just because we don’t know any better?

        I remember my brother once telling me about our mother. "She was the kindest person who ever lived," he said. "You didn’t get to know her the way I did." He was right. She died when I was too young to remember her properly. I’ve spent my whole life hearing about her goodness, her warmth, her love—but never feeling it for myself. 

        My brother said something else that stuck with me. He said, "You have low standards for love because you never learned what it’s supposed to feel like." At first, I was offended. Low standards? Me? But the more I thought about it, the more I realized he might be right. Maybe that’s why I didn’t treasure those flowers when she gave them to me. Maybe that’s why I thought love was in the little gestures, even if the bigger ones were missing.

        And now, I wonder: How many of us are like that? How many men go through life without knowing what it’s like to be truly cared for? We’re taught to be strong, to be providers, to hold it all in. We’re not taught to recognize tenderness, to cherish it when it comes our way.

        So here I am, sitting alone, thinking about those flowers. They’ve long since withered, but their meaning lingers. They remind me of her, of my brother’s words, of my mother I barely knew. They remind me of how men like me are loved and lost, often without even realizing it.

        For I am a Rasta man, and this is the story of the first flowers I ever received—and how they might just be my last while I’m still alive.`
},
        
{
  id: 7,
  title: 'The Greatest Love',
  excerpt: 'A story of magic, covenant, and love beyond measure.',
  fullText: `
    <p><strong>Scene:</strong> A tranquil hilltop at dawn. The sun is rising, casting golden light over the landscape. Chrispin, the wise and philosophical rasta man, sits cross-legged on the grass, his dreadlocks flowing with the breeze. Nearby, an unexpected guest appears—Jesus, walking with a calm, radiant presence. Chrispin looks up, intrigued, as the two settle beside one another.</p>

    <p><strong>Chrispin:</strong> <em>(gazing at Jesus with a puzzled yet curious expression)</em> Jah, you move like the wind, my friend. Ain’t no one can step like you, real talk. What’s your secret?</p>

    <p><strong>Jesus:</strong> <em>(smiling softly)</em> It’s the love of my Father that guides my steps. But you, Chrispin, you’ve got a spirit that seeks answers. Let me tell you a story.</p>

    <p><strong>Chrispin:</strong> <em>(nodding eagerly)</em> A story? I love stories, man. Hit me with it.</p>

    <p><strong>Jesus:</strong> Let us start with the beginning—Eve. She took the fruit from the tree. With her own hands, she plucked that apple and gave it to Adam. That act—small as it seemed—opened the door to sin, to suffering. But love has always been at the center of everything, even then. In that moment, when humanity faltered, I had already promised redemption.</p>

    <p><strong>Chrispin:</strong> <em>(scratching his chin)</em> Yeah, I hear dat. But you mean, all that went down because of one little apple? A whole world of trouble for an apple?</p>

    <p><strong>Jesus:</strong> <em>(looking thoughtful)</em> It’s not the fruit, Chrispin. It’s the choice, the will to decide. That moment was the first step on a long road. But, don’t forget, I came to heal that. To show a love deeper than we can understand. Remember the first prophecy in Genesis? "I will put enmity between you and the woman, and between your offspring and hers; he will crush your head, and you will strike his heel." That was my destiny—to redeem and crush the enemy.</p>

    <p><strong>Chrispin:</strong> <em>(eyes wide)</em> So, you’re saying this whole thing... all the struggles, the pain, the sin... it’s like part of the magic? Part of something bigger?</p>

    <p><strong>Jesus:</strong> <em>(nodding gently)</em> Yes, Chrispin. It’s not just magic. It’s a mystery. A divine covenant. Remember when Abraham made a covenant with God? He laid out the animals, but it was God who walked between them. He said, "May I be slain if this covenant fails." But my Father’s love never fails. It’s eternal. It’s not about what the lesser being offers, but what the greater being does. In history, when two parties make a covenant, the lesser one pledges. But God, the Creator, He walks the path of blood, showing that He will take the penalty if the covenant fails. This act demonstrates the fullness of His love and sacrifice.</p>

    <p><strong>Chrispin:</strong> <em>(nodding slowly, his eyes widening in realization)</em> So, the magic was never really about spells or power... it was always about love and promise. That’s deep, man.</p>

    <p><strong>Jesus:</strong> <em>(gently touching Chrispin’s shoulder)</em> Exactly. Now, fast forward to the cross. When I was nailed to it, remember: My feet, like the first prophecy in Genesis, were struck. The same feet that walked in the garden. My hands, the hands that held the apple, were nailed to the wood. My side—where Eve came from—was pierced, and blood and water flowed. Even my crown, a crown of thorns, was placed upon my head. The thorns that cursed the earth were now upon me, taking on the burden of sin and suffering. And let’s not forget the Nephilim and demons who wandered the earth. The giants who were born of the sons of God and daughters of men. The evil and chaos they brought into the world... Yet, even amid such darkness, love would shine through.</p>

    <p><strong>Chrispin:</strong> <em>(staring in awe)</em> That’s heavy, man. Every detail—it’s like you were connected to the beginning, all the way through to the end. It’s like... you had to take it all, every part of it, to heal us. Even the demons and giants couldn’t stop it.</p>

    <p><strong>Jesus:</strong> <em>(gazing into the distance)</em> Yes, I took it all. So that in me, love could triumph. Love is the magic that transforms the world, Chrispin. And in the end, it was this love that led to my resurrection. Even death couldn’t hold me.</p>

    <p><strong>Chrispin:</strong> <em>(smiling softly)</em> So it was all about love, huh? Everything from the start to the end... it’s a love story.</p>

    <p><strong>Jesus:</strong> <em>(smiling warmly)</em> Yes. And this love is for all. "For God so loved the world that He gave His only Begotten Son, that whosoever believes in Him should not perish but have everlasting life." That’s the greatest magic of all.</p>

    <p><strong>Chrispin:</strong> <em>(sighing in awe, his voice soft)</em> I see now, man. It wasn’t just about what you did—it’s about what love does. Love creates, it heals, it transforms. Jah bless, you’ve opened my eyes today.</p>

    <p><strong>Jesus:</strong> <em>(smiling, standing to leave)</em> And may your heart always be filled with that love, Chrispin. Walk in it, share it, and never forget—love never fails.</p>

    <p><strong>Chrispin:</strong> <em>(watching Jesus walk away, his heart full of peace)</em> Irie, man. Irie... Jah is love.</p>
  `
},
        {
    "id": 8,
    "title": "The Conquests of a Rasta King",
    "excerpt": "A journey of discipline, peace, and the realization that I am indeed royalty...",
    "fullText": `
        I am a Rasta man, and this is the tale of my small but mighty conquests. No, I did not storm castles or seize lands—my battlefield was within, and my victories? Ah, they were sweeter than honey and stronger than Samson's locks.

        First, I conquered lust. Now, don’t get me wrong—I still appreciate a beautiful woman, but I no longer stumble at the sight of curves like a man lost in the desert spotting an oasis. No more tripping over my own thoughts, no more getting hypnotized by hips. Beauty? Yes, it’s nice. But now, it’s the mind, the spirit, the way she moves through life that catches my attention. A man must not be led by his eyes alone, lest he walk straight into a pit.

        Next, anger. Ah, anger—my old friend, my old rival. We had some battles, me and him. But now, even when he knocks on my door, I don’t invite him in for tea. I take a step back, breathe, and let go in a way that doesn’t scorch the earth behind me. Because what kind of King loses himself over small things? A King must rule himself before he can rule anything else.

        And then, the greatest realization of all—I am a King. Not because of gold or crowns or thrones, but because I have learned to govern myself. And as I became a King, I also drew closer to Christ, the King of Kings. A King recognizing another King. A meeting of royalty, if you will. And with this, peace settled in me like a river flowing steady and sure.

        So here I stand, a Rasta man, victorious in my own right. No statues will be built in my honor, no bards will sing of my name, but I know—I know—that these battles were worth fighting. 

        And if I must fight again tomorrow? Then so be it. A King never stops growing, never stops ruling, never stops walking the path laid before him.

        For I am a Rasta man, and this is the story of the conquests that made me truly free.`
}

      ],
      currentPost: null,
      isModalOpen: false
    };
  },
  methods: {
    openModal(post) {
      this.currentPost = post;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    prevPost() {
      const currentIndex = this.posts.indexOf(this.currentPost);
      const prevIndex = (currentIndex - 1 + this.posts.length) % this.posts.length;
      this.currentPost = this.posts[prevIndex];
    },
    nextPost() {
      const currentIndex = this.posts.indexOf(this.currentPost);
      const nextIndex = (currentIndex + 1) % this.posts.length;
      this.currentPost = this.posts[nextIndex];
    }
  }
};
</script>


<style scoped>
.title {
  font-size: 2rem;
  margin-bottom: 20px;
}

.post {
  margin-bottom: 20px;
}

.post-preview {
  cursor: pointer;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.post-preview:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.post-title {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.post-excerpt {
  font-size: 1rem;
  color: #666;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  background-color: black;
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  animation: fadeIn 0.3s ease;
}

.modal-content h2 {
  margin-bottom: 20px;
}

.modal-content p {
  font-size: 1rem;
  line-height: 1.5;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
